module.exports = __webpack_public_path__ + "img/sub.8a71f637.png";